<script setup>
import { defineProps, computed, ref, watch } from 'vue'
import CardItem from '@/pages/global/verifyMetaData/components/CardItem.vue'
import moment from 'moment-timezone'
import lang from '@/pages/global/verifyMetaData/lang.json'
import { useRoute } from 'vue-router'

const defaultLocal =
  navigator.language === 'zh-TW' ? 'zh-TW' : navigator.language.split('-')[0]
const local = ref(defaultLocal)
const languages = new Proxy(lang, {
  get: function (target, property) {
    if (target[property]) {
      return target[property][local.value] || target[property].en
    }
    return ''
  }
})

const route = useRoute()
const photoCode = computed(() => route.params.photoCode)

const props = defineProps({
  metaData: {
    type: Object,
    default: () => ({})
  }
})
// const innerMetaData = computed(() => props.metaData)
const innerMetaData = ref({})

watch(
  () => props.metaData,
  (newVal) => {
    innerMetaData.value = newVal
  }
)
</script>

<template>
  <div class="meta-data-card">
    <div class="title">{{ languages.i_verified_metadata }}</div>
    <div class="content">
      <div class="topHalf">
        <CardItem :topMsg="languages.i_photo_code" :bottomMsg="photoCode" />
      </div>
      <div class="bottomHalf">
        <CardItem
          :topMsg="languages.i_time"
          :bottomMsg="
            innerMetaData.timestamp && innerMetaData.timezoneID
              ? moment(innerMetaData.timestamp * 1000)
                  .tz(innerMetaData.timezoneID)
                  .format('HH:mm')
              : '-'
          "
        />
        <CardItem
          :topMsg="languages.i_timesheet_date"
          :bottomMsg="
            innerMetaData.timestamp && innerMetaData.timezoneID
              ? moment(innerMetaData.timestamp * 1000)
                  .tz(innerMetaData.timezoneID)
                  .format('DD MMM YYYY')
              : '-'
          "
        />
        <CardItem
          :topMsg="languages.i_time_zone"
          :bottomMsg="innerMetaData.timezoneID || '-'"
        />
        <CardItem
          :topMsg="languages.i_photo_code_device"
          :bottomMsg="innerMetaData.deviceModel || '-'"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.meta-data-card {
  margin-top: 10px;
  border-radius: 10px;
  background: rgba(240, 245, 250, 1);

  .title {
    font-weight: 590;
    font-size: 16px;
    padding: 16px 20px;
    border-bottom: 0.5px solid rgba(163, 185, 204, 1);
    color: rgba(61, 110, 153, 1);
  }

  .content {
    padding: 30px 20px;

    .topHalf {
      margin-bottom: 30px;
    }

    .bottomHalf {
      box-sizing: border-box;
      display: grid;
      column-gap: 20px;
      row-gap: 30px;
      grid-template-columns: 50% 50%;
      grid-template-rows: auto auto;
    }
  }
}
</style>
